import { SopoDialogSettings } from "./dialog";

export interface SopoConfirmData {
    header?: string;
    body?: string;
    warning?: string;
    dontShowAgain?: string;
    dismissAfter?: number;
    okText?: string;
    cancelText?: string;
    sCss?: string[];
    verifiedLanguage?: boolean;
}

export interface SopoClubJoinConfirmData {
    header?: string;
    clubData?: IClubData;
    dismissAfter?: number;
    okText?: string;
    cancelText?: string;
    sCss?: string[];
}

export interface IClubData {
    name: string;
    imageUrl: string;
    memberCount: number;
    clubCode: string;
    clubId: string;
    creationDate: Date;
}

export const DEFAULT_SOPO_CLUB_DATA: IClubData = {
    name: "",
    imageUrl: "",
    memberCount: 0,
    clubCode: "",
    clubId: "",
    creationDate: undefined,
};

export const DEFAULT_SOPO_CONFIRM_DATA: SopoConfirmData = {
    header: '',
    body: '',
    warning: '',
    dontShowAgain: '',
    dismissAfter: 0,
    okText: 'Ok',
    cancelText: 'Cancel',
}

export const DEFAULT_SOPO_CONFIRM_HTML_DATA: SopoClubJoinConfirmData = {
    header: '',
    clubData: DEFAULT_SOPO_CLUB_DATA,
    dismissAfter: 0,
    okText: 'Ok',
    cancelText: 'Cancel',
}

export class SopoConfirmSettings extends SopoDialogSettings<SopoConfirmData> {}
export class SopoClubJoinConfirmSettings extends SopoDialogSettings<SopoClubJoinConfirmData> {}
